/* unplugin-vue-components disabled */import script from "./MaintainZone.vue?vue&type=script&lang=ts&setup=true"
export * from "./MaintainZone.vue?vue&type=script&lang=ts&setup=true"

import "./MaintainZone.vue?vue&type=style&index=0&id=bde50936&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bde50936"]])

export default __exports__